import { useMerchant } from "@/lib/useMerchant";
import DashboardHeader from "@/components/DashboardHeader";
import DashboardFooter from "@/components/DashboardFooter";
import Team from "@/pages/Team";

export default function TeamPage() {
  const { me, loading } = useMerchant();

  if (loading || !me) {
    return (
      <div className="min-h-screen bg-cream">
        <DashboardHeader me={me} />
        <div className="grid h-64 place-items-center text-sm text-ink/50">Loading…</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-cream">
      <DashboardHeader me={me} />
      {/* Team.jsx fetches its own plan/country/team data via /me and
          /team/members — no props needed here. */}
      <Team />
      <DashboardFooter />
    </div>
  );
}
